import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { KnowledgeArchiveService } from './service/knowledge-archive.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { kbArchiveInterface } from 'src/app/util/interfaces/kbArchive';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { DateService } from 'src/app/services/date/date.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SvgGearsModule } from 'src/app/page_component_item/svg-gears/svg-gears.module';

@Component({
	standalone: true,
	imports: [CommonModule, FontAwesomeModule, SvgGearsModule],
	selector: 'pcp-knowledge-archive',
	templateUrl: './knowledge-archive.component.html',
	styleUrls: ['./knowledge-archive.component.scss'],
})
export class KnowledgeArchiveComponent implements OnInit {
	faStar = faStar;

	@Output()
	leavePage = new EventEmitter();

	isLoadingKb = true;
	isLoadingLabels = true;
	isEvaluationGoingOn = false;
	view = 'kb';

	labels: LabelsInterface = {
		lbl_geral_competencia: 'Scope',
		lbl_geral_versao: 'Version',
		lbl_edocs_data_versao: 'Date version',
		lbl_geral_summary: 'Summary',
		lbl_geral_descricao: 'Description',
		lbl_status_analise_causa: 'Root cause analysis',
		lbl_asset_resolucao: 'Resolution',
		lbl_kb_aplica_se: 'Apply to',
		lbl_geral_inicio: 'Start',
		lbl_edocs_carregando: 'Loading',
		lbl_rep_custom_arquivo_nao_encontrado: 'Archive not found',
		lbl_geral_avaliar: 'Evaluate',
		lbl_geral_avaliacao: 'Evaluation',
		lbl_rate_file: 'Rate this archive',
		lbl_leave_a_comment: 'Leave a comment',
		lbl_geral_cancelar: 'Cancel',
		lbl_geral_salvar: 'Salvar',
		lbl_enquete_resposta_armazenada: 'Successfull sent',
		lbl_geral_preencha_todos_campos: 'Please fill all fields',
		lbl_kb_pontos: 'Points',
	};

	kb: kbArchiveInterface = {
		id: '',
		summary: '',
	};

	evaluationPointUntil = -1;
	evaluationCommentary = '';

	constructor(
		private Router: Router,
		private knowledgeArchiveService: KnowledgeArchiveService,
		private labelsService: LabelsService,
		private NotificationService: NotificationService,
		private ActivatedRoute: ActivatedRoute,
		public DateService: DateService
	) {}

	ngOnInit(): void {
		this.labelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});
		this.ActivatedRoute.params.subscribe((parameters) => {
			if (parameters && parameters.idKb) {
				this.kb.id = parameters.idKb;
				this.knowledgeArchiveService.getKb(this.kb.id).subscribe(
					(kb) => {
						this.kb = kb;
						this.isLoadingKb = false;
					},
					(errorRes) => {
						this.emitLeavePage();
						this.NotificationService.setNotificationMessage(this.labels.lbl_rep_custom_arquivo_nao_encontrado);
					}
				);
			}
		});

		if (localStorage.getItem('kbEvaluationStar_' + this.kb.id)) {
			this.evaluationPointUntil = <number>(<unknown>localStorage.getItem('kbEvaluationStar_' + this.kb.id));
		}
	}

	fillUntilStar(until: number): void {
		setTimeout(() => {
			for (let index = 0; index <= 4; index++) {
				document.querySelectorAll('.star-' + index).forEach((star) => star.classList.remove('covered'));
			}

			for (let index = 0; index <= until; index++) {
				document.querySelectorAll('.star-' + index).forEach((star) => star.classList.add('covered'));
			}
		}, 1);
	}

	resetEvaluation(): void {
		this.evaluationPointUntil = <number>(<unknown>localStorage.getItem('kbEvaluationStar_' + this.kb.id));
		this.isEvaluationGoingOn = false;
		this.evaluationCommentary = '';
		this.view = 'kb';
	}

	submitEvaluation(): void {
		if (this.evaluationPointUntil === -1) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencha_todos_campos);
		} else {
			let oldStar = <number>(<unknown>localStorage.getItem('kbEvaluationStar_' + this.kb.id));
			if (!oldStar) {
				oldStar = 0;
			}
			this.knowledgeArchiveService.evaluateKb(this.kb.id, this.evaluationPointUntil - oldStar).subscribe((starRes) => {
				localStorage.setItem('kbEvaluationStar_' + this.kb.id, this.evaluationPointUntil.toString());
				this.knowledgeArchiveService.getKb(this.kb.id).subscribe((kbRes) => {
					this.kb.points = kbRes.points;
				});
			});

			if (this.evaluationCommentary.trim() !== '') {
				this.knowledgeArchiveService.newKbCommentary(this.kb.id, this.evaluationCommentary);
			}

			this.NotificationService.setNotificationMessage(this.labels.lbl_enquete_resposta_armazenada);
			this.evaluationCommentary = '';
			this.view = 'kb';
			this.isEvaluationGoingOn = false;
		}
	}

	emitLeavePage(): void {
		window.history.pushState(null, '', '/home');
		this.leavePage.emit('not-chosen');
	}
}
